import styled, { css } from "styled-components";
import { breakpoints } from "./size";

const visibleScrollbar = css`
  scrollbar-width: auto;
  scrollbar-color: ${(props) => props.theme.borderColor} ${(props) => props.theme.cardBg};

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.cardBg};
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.borderColor};
    border-radius: 999px;
    border: 2px solid ${(props) => props.theme.cardBg};
  }
`;

export const ComparePageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  padding: 24px 20px 28px 0;
  font-family: "SatoshiMedium" !important;

  @media only screen and (${breakpoints.mobile}) {
    padding: 20px 0 28px;
  }
`;

export const HeaderSection = styled.div`
  margin-bottom: 18px;
  min-width: 0;
`;

export const HeaderControls = styled.div`
  margin-top: 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
`;

export const HeaderActionStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const TemplateControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
`;

export const TemplateControlsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  width: 100%;
`;

export const TemplateDropdown = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
    min-width: 0;
  }
`;

export const TemplateDropdownButton = styled.button`
  width: 100%;
  min-height: 40px;
  border: 0.5px solid ${(props) =>
    props.$active ? props.theme.green : props.theme.borderColor};
  background: ${(props) =>
    props.$active ? props.theme.accentBg : props.theme.inputBg};
  color: ${(props) => (props.$active ? props.theme.green : props.theme.white)};
  border-radius: 8px;
  padding: 9px 12px;
  cursor: pointer;
  text-align: left;
`;

export const TemplateDropdownButtonText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;

  span {
    font-family: "SatoshiMedium";
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  strong {
    font-family: "SatoshiMedium";
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0;
    text-transform: none;
    color: ${(props) => props.theme.white};
    overflow-wrap: anywhere;
  }
`;

export const TemplateDropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 50;
  border: 0.5px solid ${(props) => props.theme.dropdownBorder};
  border-radius: 8px;
  background: ${(props) => props.theme.dropdownBg};
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 260px;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  ${visibleScrollbar};
`;

export const TemplateDropdownItem = styled.div`
  width: 100%;
  position: relative;
  border: 0.5px solid ${(props) =>
    props.$active ? props.theme.green : props.theme.borderColor};
  border-radius: 7px;
  background: ${(props) =>
    props.$active ? props.theme.accentBg : "transparent"};

  &:hover {
    border-color: ${(props) => props.theme.green};
    background: ${(props) => props.theme.accentBg};
  }
`;

export const TemplateDropdownApplyButton = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 10px 42px 10px 10px;
  cursor: pointer;
`;

export const TemplateDropdownItemTop = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const TemplateDropdownItemTitle = styled.span`
  flex: 1;
  min-width: 0;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 12px;
  line-height: 16px;
  overflow-wrap: anywhere;
`;

export const TemplateDropdownItemMeta = styled.span`
  display: block;
  margin-top: 3px;
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 10px;
  line-height: 13px;
`;

export const TemplateSelectedBadge = styled.span`
  border: 1px solid ${(props) => props.theme.green};
  color: ${(props) => props.theme.green};
  border-radius: 999px;
  font-family: "SatoshiMedium";
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 1px 6px;
  flex-shrink: 0;
`;

export const TemplateDropdownDeleteButton = styled.button`
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 5px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 12px;
    height: 12px;
  }

  &:hover {
    border-color: ${(props) => props.theme.white};
  }
`;

export const TemplateDropdownEmptyState = styled.p`
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 11px;
  line-height: 15px;
  padding: 4px 2px;
`;

export const TemplateDropdownRetryButton = styled.button`
  width: 100%;
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 6px;
  background: transparent;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 8px 10px;
  cursor: pointer;
`;

export const TemplateStatusMessage = styled.p`
  margin-top: 8px;
  color: ${(props) =>
    props.$type === "error" ? props.theme.red : props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 12px;
  line-height: 16px;
`;

export const TemplateModalTitle = styled.h1`
  margin: 0;
  font-family: "SatoshiMedium";
`;

export const TemplateModalText = styled.p`
  margin-bottom: 8px;
  font-family: "SatoshiMedium";
`;

export const TemplateSaveModalBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const TemplateSaveModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  text-align: left;
  margin-bottom: 28px;

  @media only screen and (${breakpoints.mobile}) {
    margin-bottom: 24px;
  }
`;

export const TemplateSaveModalTitle = styled.h1`
  margin: 0;
  color: ${(props) => props.theme.white};
  font-family: "SpaceGrotesk";
  font-size: 28px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: 0;
  text-align: left;

  @media only screen and (${breakpoints.mobile}) {
    font-size: 24px;
  }
`;

export const TemplateSaveModalText = styled.p`
  margin: 0;
  color: ${(props) => props.theme.blueish};
  font-family: "SatoshiRegular";
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
`;

export const TemplateSaveModalField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TemplateSaveModalLabel = styled.label`
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const TemplateSaveModalInput = styled.input`
  width: 100%;
  border-radius: 16px;
  border: 1px solid ${(props) =>
    props.$hasError ? props.theme.red : props.theme.borderColor};
  background: ${(props) => props.theme.inputBg};
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 18px;
  line-height: 1.4;
  padding: 18px 22px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: ${(props) => props.theme.blueish2};
  }

  &:focus {
    border-color: ${(props) =>
      props.$hasError ? props.theme.red : props.theme.green};
    box-shadow: 0 0 0 1px
      ${(props) => (props.$hasError ? props.theme.red : props.theme.green)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  @media only screen and (${breakpoints.mobile}) {
    font-size: 16px;
    padding: 16px 18px;
  }
`;

export const TemplateSaveModalFieldFooter = styled.div`
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.$hasError ? "space-between" : "flex-end"};
  gap: 12px;
`;

export const TemplateSaveModalError = styled.p`
  margin: 0;
  color: ${(props) => props.theme.red};
  font-family: "SatoshiRegular";
  font-size: 12px;
  line-height: 1.4;
  text-align: left;
`;

export const TemplateSaveModalCount = styled.span`
  flex-shrink: 0;
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 12px;
  line-height: 1.4;
  text-align: right;
`;

export const TemplateSaveModalActions = styled.div`
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const TemplateSaveModalCancelButton = styled.button`
  align-self: center;
  border: none;
  background: transparent;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 16px;
  line-height: 1.4;
  padding: 4px 12px;
  cursor: pointer;
  opacity: 0.78;

  &:hover {
    opacity: 1;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const TemplateModalActions = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TemplateSecondaryButton = styled.button`
  width: 100%;
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 7px;
  background: transparent;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 11px 12px;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const HeaderHint = styled.p`
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 11px;
  line-height: 14px;
  max-width: 220px;
`;

export const SearchField = styled.div`
  position: relative;
  min-width: ${(props) => props.$wide ? "260px" : "220px"};
  flex: ${(props) => props.$grow ? 1 : "unset"};
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px;
  border-radius: 8px;
  border: 0.5px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.inputBg};

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
    min-width: 0;
  }

  img,
  span {
    width: 14px;
    height: 14px;
    opacity: 0.8;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 14px;
  line-height: 20px;
  outline: none;

  &::placeholder {
    color: ${(props) => props.theme.blueish2};
  }
`;

export const SearchResults = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 30;
  border: 0.5px solid ${(props) => props.theme.dropdownBorder};
  background: ${(props) => props.theme.dropdownBg};
  border-radius: 8px;
  max-height: 220px;
  overflow: auto;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  ${visibleScrollbar};
`;

export const SearchResultButton = styled.button`
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 13px;
  padding: 10px 12px;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.accentBg};
    color: ${(props) => props.theme.green};
  }
`;

export const PanelToggleButton = styled.button`
  border: 1px solid ${(props) => props.$active ? props.theme.green : props.theme.borderColor};
  background: ${(props) => props.$active ? props.theme.accentBg : props.theme.inputBg};
  color: ${(props) => props.$active ? props.theme.green : props.theme.white};
  font-family: "SatoshiMedium";
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;

  &:disabled {
    border-color: ${(props) => props.theme.borderColor};
    background: ${(props) => props.theme.inputBg};
    color: ${(props) => props.theme.blueish2};
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

export const CompareWorkspace = styled.div`
  position: relative;
  border: 1px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.cardBg};
  border-radius: 10px;
  box-shadow: 3px 2px 30px rgba(68, 68, 68, 0.12);
  min-height: calc(100vh - 220px);
  display: flex;
  overflow: hidden;
  width: 100%;
  min-width: 0;

  @media only screen and (${breakpoints.mobile}) {
    min-height: auto;
    flex-direction: column;
  }
`;

export const MainContent = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const TopHorizontalScroll = styled.div`
  flex: 0 0 auto;
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 1px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.cardBg};
  ${visibleScrollbar};

  @media only screen and (${breakpoints.mobile}) {
    display: none;
  }
`;

export const TopHorizontalScrollInner = styled.div`
  height: 1px;
  min-width: 100%;
  width: ${(props) => props.$width}px;
`;

export const MainScroll = styled.div`
  flex: 1;
  overflow: auto;
  ${visibleScrollbar};
`;

export const Table = styled.table`
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead th {
    position: sticky;
    top: 0;
    z-index: 4;
    background: ${(props) => props.theme.cardBg};
    border-bottom: 1px solid ${(props) => props.theme.borderColor};
    border-right: 1px solid ${(props) => props.theme.borderColor};
    text-align: left;
    padding: 14px 14px;
    font-family: "SatoshiMedium";
    color: ${(props) => props.theme.white};
  }

  thead th.metric-head {
    left: 0;
    z-index: 7;
    width: 220px;
    background: ${(props) => props.theme.cardBgAlt};
    color: ${(props) => props.theme.white};
    box-shadow: 4px 0 12px rgba(0, 0, 0, 0.08);
  }

  tbody td {
    border-bottom: 1px solid ${(props) => props.theme.borderColor};
    border-right: 1px solid ${(props) => props.theme.borderColor};
    padding: 10px 14px;
  }

  tbody td.metric-cell {
    position: sticky;
    left: 0;
    z-index: 5;
    background: ${(props) => props.theme.cardBgAlt};
    font-family: "SatoshiMedium";
    font-size: 13px;
    white-space: nowrap;
    box-shadow: 4px 0 12px rgba(0, 0, 0, 0.08);
    color: ${(props) => props.theme.white} !important;
  }

  tbody td.stat-cell {
    font-family: "SatoshiMedium";
    font-size: 13px;
    color: ${(props) => props.theme.white};
  }

  tbody tr.group-row td {
    background: ${(props) => props.theme.cardBgAlt};
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0;
    text-transform: none;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  tbody tr.group-row td.metric-cell {
    position: sticky;
    left: 0;
    z-index: 6;
    box-shadow: 4px 0 12px rgba(0, 0, 0, 0.08);
    color: ${(props) => props.theme.green} !important;
  }

  tbody tr.group-row td.group-fill-cell {
    border-right: 1px solid ${(props) => props.theme.borderColor};
    box-shadow: none;
  }
`;

export const MetricSortButton = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  color: ${(props) => props.theme.white} !important;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0;
  cursor: pointer;
  font: inherit;
  text-align: left;

  > span:first-child {
    color: ${(props) => props.theme.white} !important;
  }

  &:focus-visible {
    outline: none;
    color: ${(props) => props.theme.white};
  }
`;

export const MetricSortIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(props) => props.$active ? props.theme.white : props.theme.textMuted};

  svg {
    width: 12px;
    height: 12px;
    display: block;
  }
`;

export const PlayerHead = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
  padding: ${(props) => props.$draggable ? "4px" : "0"};
  background: ${(props) => props.$dragOver ? `${props.theme.green}12` : "transparent"};
  cursor: ${(props) => (props.$draggable ? (props.$dragging ? "grabbing" : "grab") : "default")};
  opacity: ${(props) => props.$dragging ? 0.55 : 1};
  transition: background 0.15s ease, opacity 0.15s ease;
`;

export const PlayerHeadTop = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const PlayerAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  border: 1px solid ${(props) => props.$color || props.theme.borderColor};
  flex-shrink: 0;

  .photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .flag {
    position: absolute;
    bottom: -1px;
    right: -1px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    object-fit: cover;
    background: ${(props) => props.theme.cardBg};
  }
`;

export const PlayerInfo = styled.div`
  min-width: 0;

  h4 {
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.01em;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  p {
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiMedium";
    font-size: 11px;
    line-height: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const PlayerNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

export const ComparePlayerLink = styled.a`
  display: block;
  max-width: 100%;
  color: inherit;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 4px;
  transition: color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    color: ${(props) => props.theme.green};
    text-decoration: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 1px ${(props) => props.theme.green};
  }
`;

export const CompareClubLink = styled.a`
  display: block;
  max-width: 100%;
  color: inherit;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 4px;
  transition: color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    color: ${(props) => props.theme.green};
    text-decoration: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 1px ${(props) => props.theme.green};
  }
`;

export const FavoritePlayerButton = styled.button`
  width: 18px;
  height: 18px;
  border: none;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  opacity: ${(props) => props.disabled ? 0.55 : 1};

  img {
    width: 16px;
    height: 16px;
    display: block;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 1px ${(props) => props.theme.green};
    border-radius: 999px;
  }
`;

export const PlayerMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const PositionBadge = styled.span`
  border: 1px solid ${(props) => props.$color || props.theme.borderColor};
  color: ${(props) => props.$color || props.theme.white};
  border-radius: 4px;
  font-family: "SatoshiMedium";
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 2px 6px;
`;

export const MiniMeta = styled.span`
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 10px;
`;

export const MiniMetaButton = styled.button`
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 10px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.white};
  }

  &:focus-visible {
    outline: none;
    color: ${(props) => props.theme.white};
  }
`;

export const PlayerSeasonSelect = styled.select`
  max-width: 110px;
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 4px;
  background: ${(props) => props.theme.inputBg};
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 10px;
  line-height: 14px;
  padding: 2px 6px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const RemovePlayerButton = styled.button`
  margin-left: auto;
  border: 1px solid ${(props) => props.theme.borderColor};
  background: transparent;
  color: ${(props) => props.theme.blueish2};
  border-radius: 4px;
  width: 22px;
  height: 22px;
  cursor: pointer;
  font-family: "SatoshiMedium";
  font-weight: 700;

  &:hover {
    color: ${(props) => props.theme.white};
    border-color: ${(props) => props.theme.white};
  }
`;

export const StatCellWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: none;
  background: ${(props) => props.$best ? `${props.$color || props.theme.green}1a` : "transparent"};
  border-radius: 6px;
  padding: 4px 6px;
  text-align: left;
  appearance: none;
  cursor: ${(props) => props.$interactive ? "pointer" : "not-allowed"};
  opacity: ${(props) => props.$disabled ? 0.55 : 1};
  transition: background 0.15s ease, opacity 0.15s ease;

  &:hover {
    background: ${(props) =>
      props.$interactive
        ? `${props.$color || props.theme.green}26`
        : props.$best
          ? `${props.$color || props.theme.green}1a`
          : "transparent"};
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${(props) =>
      props.$interactive ? `0 0 0 1px ${props.$color || props.theme.green}` : "none"};
  }
`;

export const StatBarTrack = styled.div`
  flex: 1;
  height: 4px;
  background: ${(props) => props.theme.blueish3};
  border-radius: 999px;
  overflow: hidden;
`;

export const StatBarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  width: ${(props) => props.$percent}%;
  background: ${(props) => props.$best ? (props.$color || props.theme.green) : `${props.$color || props.theme.green}66`};
`;

export const StatValue = styled.span`
  text-align: right;
  color: ${(props) => props.$best ? (props.$color || props.theme.green) : props.theme.white};
  font-family: "SatoshiMedium";
  font-weight: ${(props) => props.$best ? 700 : 500};
  font-size: 12px;
`;

export const StatValueGroup = styled.span`
  min-width: 52px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  color: inherit;
`;

export const StatVideoIcon = styled.svg`
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  color: ${(props) => props.$best ? (props.$color || props.theme.green) : props.theme.white};
  opacity: ${(props) => props.$interactive ? 1 : 0.55};
  transition: color 0.15s ease, opacity 0.15s ease;
`;

export const EmptyState = styled.div`
  padding: 28px;
  text-align: center;
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
`;

export const RadarWrap = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 26px 18px;
  gap: 18px;
`;

export const RadarLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 14px;
`;

export const RadarLegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 12px;
`;

export const RadarLegendDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => props.$color};
`;

export const RadarHint = styled.p`
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 11px;
`;

export const ControlPanel = styled.aside`
  width: ${(props) => props.$open ? "260px" : "0"};
  opacity: ${(props) => props.$open ? 1 : 0};
  border-left: ${(props) => props.$open ? `1px solid ${props.theme.borderColor}` : "none"};
  transition: width 0.2s ease, opacity 0.2s ease;
  overflow: hidden;
  flex-shrink: 0;

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
    opacity: 1;
    border-left: none;
    border-top: ${(props) => props.$open ? `1px solid ${props.theme.borderColor}` : "none"};
    max-height: ${(props) => props.$open ? "1000px" : "0"};
    transition: max-height 0.2s ease;
  }
`;

export const ControlPanelInner = styled.div`
  width: 260px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.cardBgAlt};
  overflow-y: auto;
  ${visibleScrollbar};

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const PanelSection = styled.div`
  padding: 14px;
  border-bottom: 1px solid ${(props) => props.theme.borderColor};
`;

export const PanelLabel = styled.div`
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 8px;
`;

export const PanelHelperText = styled.p`
  margin: 0 0 8px;
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 11px;
  line-height: 14px;
`;

export const ModeButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
`;

export const ModeButton = styled.button`
  border-radius: 6px;
  border: 1px solid ${(props) => props.$active ? props.theme.green : props.theme.borderColor};
  background: ${(props) => props.$active ? props.theme.accentBg : "transparent"};
  color: ${(props) => props.$active ? props.theme.green : props.theme.white};
  font-family: "SatoshiMedium";
  font-weight: 700;
  font-size: 11px;
  padding: 7px 8px;
  cursor: pointer;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const ToggleMeta = styled.div`
  h4 {
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 12px;
    line-height: 16px;
  }

  p {
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiMedium";
    font-size: 10px;
    line-height: 14px;
  }
`;

export const ToggleButton = styled.button`
  width: 36px;
  height: 20px;
  border: none;
  border-radius: 999px;
  background: ${(props) => props.$on ? props.theme.green : props.theme.blueish3};
  position: relative;
  cursor: pointer;
`;

export const ToggleThumb = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${(props) => props.theme.white};
  position: absolute;
  top: 3px;
  left: ${(props) => props.$on ? "19px" : "3px"};
  transition: left 0.15s ease;
`;

export const CategoryButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const CategoryButton = styled.button`
  border: 1px solid ${(props) => props.$active ? props.theme.green : props.theme.borderColor};
  background: ${(props) => props.$active ? props.theme.accentBg : "transparent"};
  color: ${(props) => props.$active ? props.theme.green : props.theme.white};
  border-radius: 6px;
  cursor: pointer;
  font-family: "SatoshiMedium";
  font-size: 12px;
  text-align: left;
  padding: 8px 9px;
`;

export const ParameterList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ParameterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 6px;
  padding: 6px;
  background: ${(props) => props.$unavailable ? "rgba(242, 10, 70, 0.08)" : "transparent"};
`;

export const ParameterInfo = styled.div`
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ParameterName = styled.span`
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 12px;
  line-height: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ParameterBadge = styled.span`
  border-radius: 999px;
  border: 1px solid ${(props) => props.$variant === "unavailable" ? props.theme.red : props.theme.green};
  color: ${(props) => props.$variant === "unavailable" ? props.theme.red : props.theme.green};
  font-family: "SatoshiMedium";
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 1px 6px;
  flex-shrink: 0;
`;

export const ParameterModeSelect = styled.select`
  max-width: 90px;
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.inputBg};
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 11px;
  line-height: 14px;
  padding: 4px 6px;
  outline: none;
  cursor: pointer;
`;

export const ParameterActionButton = styled.button`
  width: 24px;
  height: 24px;
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 4px;
  background: transparent;
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    border-color: ${(props) => props.theme.white};
    color: ${(props) => props.theme.white};
  }
`;

export const ParameterSearchInput = styled.input`
  width: 100%;
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.borderColor};
  background: transparent;
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 12px;
  line-height: 16px;
  padding: 7px 8px;
  outline: none;

  &::placeholder {
    color: ${(props) => props.theme.blueish2};
  }
`;

export const ParameterAddList = styled.div`
  margin-top: 8px;
  max-height: 180px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  ${visibleScrollbar};
`;

export const ParameterEmpty = styled.p`
  color: ${(props) => props.theme.blueish2};
  font-family: "SatoshiMedium";
  font-size: 11px;
  line-height: 14px;
`;

export const LegendList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendColor = styled.span`
  width: 4px;
  height: 28px;
  border-radius: 999px;
  background: ${(props) => props.$color};
`;

export const LegendText = styled.div`
  min-width: 0;

  h4 {
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 12px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  p {
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiMedium";
    font-size: 10px;
    line-height: 14px;
  }
`;

export const RemoveAllButton = styled.button`
  width: 100%;
  border: none;
  border-radius: 7px;
  background: ${(props) => props.theme.green};
  color: ${(props) => props.theme.black};
  font-family: "SatoshiMedium";
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 10px;
  cursor: pointer;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: ${(props) => props.theme.cardBg}99;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 40;
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.35);
  border-top-color: ${(props) => props.theme.green};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const CompareAccessDenied = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 21, 33, 0.96);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000;
  pointer-events: all;
  backdrop-filter: blur(2px);
  font-family: "SatoshiMedium";
  font-weight: 700;
  font-size: 28px;
  text-align: center;
  padding: 24px;
`;
